const theme = {
  palette: {
    primary: {
      ligth: '#5c6183',
      main: '#484d68',
      dark: '#242631',
      contrastText: '#fff',
    },
    secondary: {
      ligth: '#ff9255',
      main: '#f07f3f',
      dark: '#b15927',
      contrastText: '#fff',
    },
    error: {
      ligth: '#ff5c39',
      main: '#ff2c00',
      dark: '#c62200',
      contrastText: '#fff',
    },
    charts: {
      green: '#0088FE',
      yellow: '#00C49F',
      red: '#FFBB28',
      blue: '#FF8042',
    },
  },
  overrides: {
    RaNotification: {
      success: {
        color: 'white',
        backgroundColor: '#20a89a',
      },
    },
  },
};

export default theme;
